<template>
    <v-container class="pa-0 pt-2 px-0">
        <v-row  class="pa-6" v-show="emptyChart">
        <p>Não foram encontrados dados para o período.</p>
        </v-row>
        <chart :id="'chartPie'+this.chartId" :options="option" v-show="!emptyChart"/>
    </v-container>
</template>

<script>
import { mapActions } from "vuex"
import ECharts from "vue-echarts"
import echarts from "echarts"
// import moment from "moment"
export default {
    components: {
        chart: ECharts,
    },
    data() {
        return {
            option: {},
            emptyChart: false
        }
    },
    props: {
        dadosGrafico: Object,
        dicionario: Object,
        chartId: String
    },
    watch: {
        chartId(val) {
            console.info(val)
            this.chartsBar()
            this.emptyChart = !this.dadosGrafico.periodo.length>0
        }
    },
    mounted() {
        this.chartsBar()
    },
    methods: {
        ...mapActions('autorizador', [
            "setFilter"
        ]),
        chartsBar() {
            //Iniciando variáveis
            let dados = {...this.dadosGrafico.grafico}
            let series =[]

            let fontSize = this.dadosGrafico.periodo.length >= 10 ? 8 : 12
            this.emptyChart = this.dadosGrafico.periodo ? !this.dadosGrafico.periodo.length>0  : true
            // let colorsList = ["#32B88B", "#B2B842", "#FC9D0A", "#FC5F17", "#D0021B", "#4A4A4A", "#979797"]

            let categorias = Object.keys(dados)
            categorias.forEach((el) => {
                let item = {
                    name: this.dicionario[el],
                    type: 'bar',
                    barGap: 0,
                    emphasis: {
                        focus: 'category'
                    },
                    data: dados[el],
                }
                if(this.dadosGrafico.periodo.length <= 4){ 
                    item.barWidth=30
                } 
                series.push(item)
            })

            this.option = {
                color:['#118ACA',"#32B88B", '#D0021B',  '#979797'],
                // color: [ '#118ACA', '#B2B842', '#D0021B',  '#979797' ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {           
                        type: 'none'       
                    }
                },
                grid: {
                    left: '2%',
                    right: '3%',
                    bottom: '6%',
                    top: '8%',
                    containLabel: true
                },
                title: {
                    subtext: 'Evolução do Faturamento',
                    left: '1%',
                    top: '-5%'
                },
                xAxis: {
                    type: 'category',
                    data: [...this.dadosGrafico.periodo],
                    axisLabel: {
                        textStyle: {
                            color: '##4A4A4A',
                            fontSize: fontSize,
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#4a4a4a1f",
                        },
                    },
                },
                series: series
            };
            this['chartPie'+this.chartId] =  echarts.init(document.getElementById(this.id));
            // this['chartPie'+this.chartId].on('click', () => {
            //     // let status = { seriesId: params.seriesId }
            //     // let data_inicio = moment(this.list.data_referencia).startOf('month').format('YYYY-MM-DD')
            //     // let data_fim = moment(this.list.data_referencia).endOf('month').format('YYYY-MM-DD')
            //     // let operadora_ans_id = this.list.operadoras[params.dataIndex]
            //     // let periodo = "mes"
            //     // this.setFilter({data_inicio, data_fim, operadora_ans_id, periodo, status})
            // });
        },
    },
}
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 300px;
}
.chart-date {
    font-family: sans-serif;
    font-size: 17px;
    color: black;
}
</style>